var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 11.2,
    fill: "#EAECF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3332 16.6479V21.4669C30.3332 22.1203 30.3332 22.447 30.4603 22.6966C30.5722 22.9161 30.7507 23.0946 30.9702 23.2064C31.2197 23.3336 31.5464 23.3336 32.1998 23.3336H37.0188M32.6665 29.1668H23.3332M32.6665 33.8335H23.3332M25.6665 24.5002H23.3332M30.3332 16.3335H24.2665C22.3063 16.3335 21.3262 16.3335 20.5775 16.715C19.919 17.0505 19.3835 17.586 19.048 18.2445C18.6665 18.9932 18.6665 19.9733 18.6665 21.9335V34.0668C18.6665 36.027 18.6665 37.0071 19.048 37.7558C19.3835 38.4144 19.919 38.9498 20.5775 39.2854C21.3262 39.6668 22.3063 39.6668 24.2665 39.6668H31.7332C33.6934 39.6668 34.6734 39.6668 35.4221 39.2854C36.0807 38.9498 36.6161 38.4144 36.9517 37.7558C37.3332 37.0071 37.3332 36.027 37.3332 34.0668V23.3335L30.3332 16.3335Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegion);
export default __webpack_public_path__ + "static/media/Region.6acbecc8fa6b7cbb8ce1783f8cd0c4ed.svg";
export { ForwardRef as ReactComponent };